import { format } from 'date-fns';
import { WeekDay } from '../Datepicker.types';

export const formatDayLabel = (weekDay: WeekDay): string => format(weekDay.value, 'EEE');
